import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
 const navigate = useNavigate();
 const { setUser } = useAuth();
 const hasProcessed = useRef(false);

 useEffect(() =>{
 if (hasProcessed.current) return;
 hasProcessed.current = true;

 const hash = window.location.hash || "";
 const m = hash.match(/session_id=([^&]+)/);
 if (!m) {
 navigate("/login", { replace: true });
 return;
 }
 const session_id = decodeURIComponent(m[1]);
 (async () =>{
 try {
 const { data } = await api.post("/auth/google/session", { session_id });
 setUser(data);
 window.history.replaceState(null, "", "/dashboard");
 navigate("/dashboard", { replace: true, state: { user: data } });
 toast.success(`Bem-vindo(a), ${data.name}!`);
 } catch (e) {
 toast.error(formatApiError(e.response?.data?.detail) || "Falha no login com Google");
 navigate("/login", { replace: true });
 }
 })();
 }, [navigate, setUser]);

 return (<div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback"><div className="text-slate-600">Conectando sua conta Google...</div></div>);
}
